import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import RankingSection from './components/RankingSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { featuredComics, newComics } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩国漫画网',
  url: 'http://sweetbird.cn/',
  description: '韩国漫画网提供免费漫画大全和好看的韩漫推荐，无遮挡下拉式阅读模式确保在线体验舒适流畅。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://sweetbird.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩国漫画网',
  url: 'http://sweetbird.cn/',
  description: '专注韩国漫画的免费在线阅读平台，提供丰富的韩漫资源和舒适的下拉式阅读体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@sweetbird.cn',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画网-免费漫画大全-好看的韩国漫画推荐-无遮挡下拉式韩漫在线阅读"
        description="韩国漫画网提供免费漫画大全和好看的韩漫推荐，无遮挡下拉式阅读模式确保在线体验舒适流畅，让您专注于漫画情节本身。收录恋爱、奇幻、动作、悬疑、搞笑等各类热门韩国漫画。"
        keywords="韩国漫画,韩漫,免费漫画,漫画大全,韩漫推荐,下拉式阅读,在线漫画,漫画在线阅读"
        canonicalUrl="http://sweetbird.cn/"
      />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <PopularSection
          title="热门韩漫推荐"
          subtitle="精选最受欢迎的韩国漫画，每部都是读者口碑之选"
          comics={featuredComics}
          viewAllLink="/category/all"
        />
        <TestimonialSection />
        <RankingSection />
        <PopularSection
          title="最新上架"
          subtitle="刚刚上线的新鲜韩漫，第一时间尝鲜阅读"
          comics={newComics}
          viewAllLink="/category/all"
        />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}